export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Roman.3f0d96f.woff";